export default __webpack_public_path__ + "static/media/03_sister.6bef32ef.png";